export enum RiskProfilers {
    EVALUE_ONE_TO_FIVE = 'EVALUE_ONE_TO_FIVE',
    EVALUE_ONE_TO_TEN = 'EVALUE_ONE_TO_TEN',
    DEFAQTO = 'DEFAQTO',
    DYNAMIC_PLANNER = 'DYNAMIC_PLANNER',
    OXFORD_RISK = 'OXFORD_RISK',
}
